// import psyImages from "../components/utility/psychologicalImageImports";
const vacationChoicesSrb = [
  {
    label:
      "Тихи одмор у минималистичком сивом спа центру са мистериозним пећинама у близини.",

    value:
      'A quiet retreat in a minimalist, gray spa with mysterious caves nearby.{"Gray":"3","Black":"2"}',
    // imageUrl: psyImages["vacation/forFormA.png"],
  },
  {
    label: "Спокојна плажа са плавим водама и сумраком на небу.",
    value:
      'A serene beach with azure waters and twilight in the sky.{"Blue":"3","Violet":"2"}',
    // imageUrl: psyImages["vacation/forFormB.png"],
  },

  {
    label: "Бујна зелена шума са високим зеленим дрвећем и земљаним браон стазама.",
    value:
      'A lush green forest with tall green trees and earthy brown paths.{"Green":"3","Brown":"2"}',
    // imageUrl: psyImages["vacation/forFormC.png"],
  },

  {
    label: "Живахни град са интензивним ноћним животом и сунчаним отвореним парковима.",
    value:
      'A bustling city with intense nightlife and sunny, open parks.{"Red":"3","Yellow":"2"}',
    // imageUrl: psyImages["vacation/forFormD.png"],
  },
];

export default vacationChoicesSrb;
